module.exports = __webpack_public_path__ + "img/4.655d9828.png";